import React, { useState } from 'react';
import { Button, Form, Tooltip } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import translateApi from 'libs/api/translate';
import UIHelper from 'helpers/UIHelper';

const labelWrapperStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap',
  fontSize: 14,
  // lineHeight: '22px',
};

const TranslateInputAddon = ({
  form,
  sourceField,
  textKey,
  targetFields,
  disabled,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const sourceValue = Form.useWatch(sourceField, form);

  const handleTranslate = async (event) => {
    event.stopPropagation();

    const value = form.getFieldValue(sourceField)?.trim();
    if (!value || loading || disabled) {
      return;
    }

    setLoading(true);
    try {
      const targetLocales = Object.keys(targetFields);
      const { data } = await translateApi.translate(
        { [textKey]: value },
        targetLocales,
      );
      const translations = data?.translations || {};
      const fieldsToSet = targetLocales
        .filter((locale) => translations[locale]?.[textKey] != null)
        .map((locale) => ({
          name: targetFields[locale],
          value: translations[locale][textKey],
        }));

      if (fieldsToSet.length) {
        form.setFields(fieldsToSet);
      }
    } catch {
      UIHelper.openNotificationWithIcon('error', t('Traduzione non riuscita'));
    } finally {
      setLoading(false);
    }
  };

  if (!sourceValue?.trim() || disabled) {
    return null;
  }

  return (
    <Tooltip
      title={t(
        'Inserisci contenuti in italiano, e poi clicca per tradurere sulle varie lingue',
      )}
    >
      <Button
        type='primary'
        size='small'
        htmlType='button'
        icon={<RobotOutlined />}
        loading={loading}
        onClick={handleTranslate}
        style={{
          fontSize: 10,
          // lineHeight: '22px',
          // height: 20,
          padding: '0 7px',
        }}
      >
        {t('Traduci con AI')}
      </Button>
    </Tooltip>
  );
};

export const TranslateFormLabel = ({
  label,
  form,
  sourceField,
  textKey,
  targetFields,
  disabled,
}) => (
  <span style={labelWrapperStyle}>
    {label}
    <TranslateInputAddon
      form={form}
      sourceField={sourceField}
      textKey={textKey}
      targetFields={targetFields}
      disabled={disabled}
    />
  </span>
);

export default TranslateInputAddon;
